import type { IconNode } from '../types';

/**
 * @name bath-bubble
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgM2guMDEiIC8+CiAgPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjYuNSIgcj0iLjUiIC8+CiAgPGNpcmNsZSBjeD0iMTYuNSIgY3k9IjcuNSIgcj0iLjUiIC8+CiAgPHBhdGggZD0iTTIgMTJoNiIgLz4KICA8cGF0aCBkPSJNMTMgMTVIOHYtM2MwLS42LjQtMSAxLTFoM2MuNiAwIDEgLjQgMSAxWiIgLz4KICA8cGF0aCBkPSJNMTMgMTJoOSIgLz4KICA8cGF0aCBkPSJNNCAxMnY1YTIgMiAwIDAgMCAyIDJoMTJhMiAyIDAgMCAwIDItMnYtNSIgLz4KICA8cGF0aCBkPSJNNyAxOXYyIiAvPgogIDxwYXRoIGQ9Ik0xNyAxOXYyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bath-bubble
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bathBubble: IconNode = [
  ['path', { d: 'M15 3h.01', key: 'ri51l3' }],
  ['circle', { cx: '11.5', cy: '6.5', r: '.5', key: '15df4q' }],
  ['circle', { cx: '16.5', cy: '7.5', r: '.5', key: '1kog09' }],
  ['path', { d: 'M2 12h6', key: '1wqiqv' }],
  ['path', { d: 'M13 15H8v-3c0-.6.4-1 1-1h3c.6 0 1 .4 1 1Z', key: '1qladh' }],
  ['path', { d: 'M13 12h9', key: '1cghjl' }],
  ['path', { d: 'M4 12v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5', key: '6a3ukr' }],
  ['path', { d: 'M7 19v2', key: '12npes' }],
  ['path', { d: 'M17 19v2', key: 'ts1sot' }],
];

export default bathBubble;
